<template>
    <flex-element :tag="renderedTag" :element-type="elementType">
        <slot :element="element" :elements-new="elementsNew" :element-updated="elementUpdated" />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

export default {
    name: 'o-container',
    mixins: [baseOrganism],

    props: {
        tag: {
            type: String,
            default: 'div',
        },
    },

    computed: {
        renderedTag() {
            return this.tag || 'div';
        },
    },
};
</script>
